export function getCssVariable(name) {
    return window.getComputedStyle(document.body).getPropertyValue(`--${name}`);
}
/**
 * Gets the value of the CSS variable starting with
 * "--color-chart-"" combined with the provided name.
 * @param name Something like heat-series-1
 * @returns The hex value of the color or white as a fallback.
 */
export function getCssChartColor(name) {
    return getCssVariable(`color-chart-${name}`) || "#ffffff";
}
/**
 * Gets the color for the provided string such as heat-series-1
 * or a hex value.
 * @param str Something like #abcdef or heat-series-1
 * @returns The hex color value.
 */
export function getColor(str) {
    if (!str) {
        return "";
    }
    if (str[0] === "#") {
        return str;
    }
    return getCssChartColor(str);
}
//# sourceMappingURL=cssColor.js.map